import { useAuth0 } from '@auth0/auth0-react';
import { FC, ReactElement } from 'react';
import { RoleType } from 'utils';
import useEvolveUser from '../../hooks/useEvolveUser';
import AccessDenied from '../../pages/AccessDenied';
import { LoadingScreen } from '../LoadingScreen';

interface ProtectedRouteProps {
  showWhenAuthenticated: ReactElement;
  requireRoles?: RoleType[];
}

export const ProtectedRoute: FC<ProtectedRouteProps> = (props: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const currentUser = useEvolveUser();

  // Mostrar loading mientras Auth0 está cargando
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Si no está autenticado, redirigir al login y mostrar loading
  if (!isAuthenticated) {
    loginWithRedirect().catch((error) => {
      console.error('Error en loginWithRedirect:', error);
    });
    // IMPORTANTE: Retornar LoadingScreen aquí para evitar renderizar los componentes hijos
    // antes de redirigir. Esto previene errores de hooks inconsistentes.
    return <LoadingScreen />;
  }

  // Esperar a que el usuario esté cargado
  if (!currentUser) {
    return <LoadingScreen />;
  }

  // Validar roles si se especifican
  const rolesToCheck = props.requireRoles || [
    RoleType.Administrator,
    RoleType.Staff,
    RoleType.Manager,
    RoleType.Provider,
    RoleType.CustomerSupport,
  ];

  const hasValidRole = currentUser.hasRole(rolesToCheck);

  if (!hasValidRole) {
    // Usuario sin rol válido: mostrar página de acceso denegado
    return <AccessDenied />;
  }

  // Usuario autenticado con rol válido: mostrar el contenido protegido
  return props.showWhenAuthenticated;
};
